import React from "react"
import style from "./linkButton.module.css"

export default ({to, children}) => (
    <a className={style.button} href={to} >
        <div className={style.symbol}>
            { children }
        </div>
    </a>
)